import {
  TEMPLATES_BATCH_DELETE_REQUEST,
  TEMPLATES_BATCH_DELETE_SUCCESS,
  TEMPLATES_BATCH_DELETE_FAILURE,
  TEMPLATES_FETCH_MANY_REQUEST,
  TEMPLATES_FETCH_MANY_SUCCESS,
  TEMPLATES_FETCH_MANY_FAILURE,
  TEMPLATES_FETCH_REQUEST,
  TEMPLATES_FETCH_SUCCESS,
  TEMPLATES_FETCH_FAILURE,
  TEMPLATES_SAVE_REQUEST,
  TEMPLATES_SAVE_SUCCESS,
  TEMPLATES_SAVE_FAILURE,

  EMPTY_TEMPLATES,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(TEMPLATES_BATCH_DELETE_REQUEST)
    return window.axios.post('/templates', { _method: 'DELETE', ids }).then(response => {
      commit(TEMPLATES_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(TEMPLATES_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1 }) {
    commit(TEMPLATES_FETCH_MANY_REQUEST)
    return window.axios.get('/templates', { params: { query, page } }).then(response => {
      commit(TEMPLATES_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(TEMPLATES_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(TEMPLATES_FETCH_REQUEST)
    return window.axios.get(`/templates/${id}`).then(response => {
      commit(TEMPLATES_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(TEMPLATES_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, template) {
    const path = template.id ? `/templates/${template.id}` : '/templates'
    const method = template.id ? 'put' : 'post'

    commit(TEMPLATES_SAVE_REQUEST)
    return window.axios[method](path, template).then(response => {
      commit(TEMPLATES_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(TEMPLATES_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(TEMPLATES_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_TEMPLATES);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
